import Icon from "@/components/icons";
import useTranslations from "@/i18n/useTranslations";

type EnrollmentCardProps = {
  enrollmentCount: number;
};

export default function EnrollmentCard({
  enrollmentCount,
}: EnrollmentCardProps) {
  const t = useTranslations("Course");
  return (
    <div className="col-span-2 rounded-xl bg-white p-4">
      <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
        <Icon type="people" svgProps={{ className: "size-12" }} />
        <p className="text-center text-base text-gray-800 m-0">
          <span className="font-bold">{enrollmentCount.toLocaleString()}</span>{" "}
          <span className="block md:inline">{t("learnersEnrolled")}</span>
        </p>
      </div>
    </div>
  );
}
